import { gql } from '@apollo/client';

export const SUBSCRIBE_NEWSLETTER = gql`
  mutation SUBSCRIBE_NEWSLETTER($input: NewsletterInput!) {
    subscribeNewsletter(input: $input)
  }
`;
